export const ONE_BILLION = 1000000000;
export const ONE_MILLION = 1000000;
export const TABLE_NULL_VALUE = "-";
export const NULLABLE_VALUES = [
  TABLE_NULL_VALUE,
  "N/A",
  "NA",
  "n/a",
  "na",
  "null",
  "NULL",
];

export const VOTER_SUFFIX = "_voter";

export enum YesNo {
  YES = "Yes",
  NO = "No",
}

export const SYSTEM_USER_ID = "compass-atlas";
export const SYSTEM_USER_DISPLAY_NAME = "Compass Atlas";

export const isSystemUser = (userId: string | null | undefined): boolean =>
  userId === SYSTEM_USER_ID;

export const resolveDisplayName = (userId: string): string =>
  isSystemUser(userId) ? SYSTEM_USER_DISPLAY_NAME : userId;
